module.exports = __webpack_public_path__ + "img/0Q3A9771_L_BlackMatted_MockedUp.86f681a1.jpg";